import React, { Component } from "react";
import propertiesStyle from "./Properties.module.css";
import styles from "./AutoFollow.module.css";
import TriangleDown from "../../SVG/TriangleDown";
import TriangleRight from "../../SVG/TriangleRight";
import { setProperty as SET_PROPERTY } from "../../Scripts/PropertyUtils";
import DragInput from "../DragInput/DragInput";

export default class CopyText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colorClicked: false,
      open: false,
    };
  }

  updateProperty(property, value) {
    SET_PROPERTY(this.props.item, property, value);
    this.setState({ update: true });
  }

  colorClicked(e) {
    this.setState({
      colorClicked: !this.state.colorClicked,
    });
  }

  handleMouseDown(e, property, startValue) {
    this.property = property;
    this.mouseDown = true;
    var rect = document.querySelector("body").getBoundingClientRect();
    var x = e.clientX - rect.left; //x position within the element.
    this.startX = x;

    this.startValue = startValue;
    document.addEventListener("mousemove", this.handleMouseMove.bind(this));
    document.addEventListener("mouseup", this.handleMouseUp.bind(this));
  }

  handleMouseMove(e) {
    if (this.mouseDown) {
      var rect = document.querySelector("body").getBoundingClientRect();
      var x = e.clientX - rect.left; //x position within the element.
      x = x - this.startX;

      this.updateProperty(this.property, this.startValue + x);
    }
  }

  handleMouseUp(e) {
    this.mouseDown = false;
    document.removeEventListener("mousemove", this.handleMouseMove.bind(this));
    document.removeEventListener("mouseup", this.handleMouseUp.bind(this));
  }

  applyCopyText(item) {
    if (this.props.item.copyText) {
      this.props.item.copyText = null;
      return;
    }
    this.props.item.copyText = item;
    try {
      let func = new Function(
        "hyperAPI",
        "currentItem",
        `
          let window = '';
   
           function update() {
         
            if (currentItem.copyText) {
            const target = currentItem.copyText
             if (target.text !== undefined && currentItem.text !== target.text) {
             hyperAPI.setProperty(currentItem, 'text', target.text)
             currentItem.text = target.text
             hyperAPI.updateText(currentItem)
             console.log(currentItem.text)
            }
           }
          }
            return {
              update: update
            };
          `
      )(window.hyperAPI, this.props.item);

      this.props.item.copyTextCode = func;
    } catch (err) {}
  }

  getTextItems = (items) => {
    let textItems = [];
    items.forEach((item) => {
      if (item.type === "TEXT") {
        textItems.push(item);
      }
      else if (item.type === "GROUP" && item.children) {
        textItems = textItems.concat(this.getTextItems(item.children));
      }
    });
    return textItems;
  }

  renderChild(children) {
    return children.map((item) => {
      return (
        <div>
          <div
            onClick={() => this.applyCopyText(item)}
            className={`${styles.Item} ${
              item === this.props.item.copyText ? styles.Active : ""
            }`}
          >
            {item.name}
          </div>
          {this.renderChild(item.children)}
        </div>
      );
    });
  }

  render() {
    return (
      <div className={propertiesStyle.Group}>
        <div
          className={propertiesStyle.GroupTitle}
          onClick={() => this.setState({ open: !this.state.open })}
        >
          <div className={propertiesStyle.Open}>
            {this.state.open && <TriangleDown />}
            {!this.state.open && <TriangleRight />}
          </div>
          <div className={propertiesStyle.Title}>Inherit Text</div>
        </div>
        {this.state.open && (
          <div className={styles.Group}>
            <div className={styles.lists}>
              <div className={styles.Property}>
                {this.renderChild(this.getTextItems(this.props.scene.children))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
